import { getAPI } from "../../../../api/Networking";
import { OpsAnalyticsData } from "../../../../models/Dashboard/OpsDashboard/OpsAnalytics";
import {
  AnalyticsGraphResponse,
  LabelValue,
} from "../../../../models/Dashboard/Analytics";
import dayjs from "dayjs";
import { UnpaidSamplesAnalyticsAPIFilters } from "../../../../models/Dashboard/UnpaidSamplesDashboard/UnpaidSamplesAnalyticsDashboardAPIFilters";

export default class UnpaidSamplesAnalyticsDashboardAPI {
  getTatsData = async (
    url: string,
    filters: UnpaidSamplesAnalyticsAPIFilters
  ): Promise<LabelValue[] | AnalyticsGraphResponse[] | OpsAnalyticsData> => {
    try {
      const start_date = dayjs(filters.start_date, "YYYY-MM-DD")
        .utc()
        .format("YYYY-MM-DD HH:mm:ss");

      const end_date = dayjs(filters.end_date, "YYYY-MM-DD")
        .add(1, "day")
        .utc()
        .format("YYYY-MM-DD HH:mm:ss");

      const queryParams = new URLSearchParams();

      if (start_date) queryParams.append("start_date", start_date);

      if (end_date) queryParams.append("end_date", end_date);

      if (filters.sales_admin_id && filters.sales_admin_id.length > 0) {
        queryParams.append(
          "sales_admin_id",
          filters.sales_admin_id.map((item) => item.id).join(",")
        );
      }

      if (filters.customer_id && filters.customer_id.length > 0) {
        queryParams.append(
          "customer_id",
          filters.customer_id.map((item) => item.id).join(",")
        );
      }

      if (filters.archived && filters.archived.length > 0) {
        const archivedValue = filters.archived[0].value;
        if (archivedValue !== "All") {
          queryParams.append("archived", archivedValue);
        }
      }

      if (filters.order_id && filters.order_id.length > 0) {
        queryParams.append(
          "order_id",
          filters.order_id.map((item) => item.id).join(",")
        );
      }

      if (filters.pending_since && filters.pending_since.length > 0) {
        queryParams.append("pending_since", filters.pending_since[0].id);
      }

      const response = await getAPI(
        `/v5/sales-analytics/unpaid-samples/${url}?${queryParams.toString()}`
      );
      return response.result;
    } catch (error) {
      throw error;
    }
  };

  getUnpaidSamplesData = async (
    url: string,
    filters: UnpaidSamplesAnalyticsAPIFilters
  ): Promise<any> => {
    try {
      const page_no = filters.page_no;
      const limit = filters.limit;

      const start_date = dayjs(filters.start_date, "YYYY-MM-DD")
        .utc()
        .format("YYYY-MM-DD HH:mm:ss");

      const end_date = dayjs(filters.end_date, "YYYY-MM-DD")
        .add(1, "day")
        .utc()
        .format("YYYY-MM-DD HH:mm:ss");

      const queryParams = new URLSearchParams();

      if (page_no) queryParams.append("page_no", page_no.toString());

      if (limit) queryParams.append("limit", limit.toString());

      if (start_date) queryParams.append("start_date", start_date);

      if (end_date) queryParams.append("end_date", end_date);

      if (filters.sales_admin_id && filters.sales_admin_id.length > 0) {
        queryParams.append(
          "sales_admin_id",
          filters.sales_admin_id.map((item) => item.id).join(",")
        );
      }

      if (filters.customer_id && filters.customer_id.length > 0) {
        queryParams.append(
          "customer_id",
          filters.customer_id.map((item) => item.id).join(",")
        );
      }

      if (filters.sort_by) queryParams.append("sort_by", filters.sort_by);

      if (filters.sort_type) queryParams.append("sort_type", filters.sort_type);

      if (filters.archived && filters.archived.length > 0) {
        const archivedValue = filters.archived[0].value;
        if (archivedValue !== "All") {
          queryParams.append("archived", archivedValue);
        }
      }

      if (filters.order_id && filters.order_id.length > 0) {
        queryParams.append(
          "order_id",
          filters.order_id.map((item) => item.id).join(",")
        );
      }
      if (filters.pending_since && filters.pending_since.length > 0) {
        queryParams.append("pending_since", filters.pending_since[0].id);
      }

      const response = await getAPI(
        `/v5/sales-analytics/unpaid-samples/${url}?${queryParams.toString()}`
      );
      return response.result;
    } catch (error) {
      throw error;
    }
  };
}
